import { Box, Grid, GridProps } from '@mui/material';
import React from 'react';

export const GridContainer16 = (props: GridProps) => (
  <Grid container columnSpacing={1} rowSpacing={2} columns={16} {...props} />
);
export const GridItem16 = (props: GridProps) => (
  <Grid item xs={16} sm={8} md={4} lg={2} {...props} />
);

export const FullWidthGridItem16 = (props: GridProps) => (
  <GridItem16 xs={16} sm={16} md={16} lg={16} {...props} />
);

export const HalfWidthOnLgGridItem16 = (props: GridProps) => (
  <GridItem16 xs={16} sm={16} md={16} lg={8} {...props} />
);

export const DoubleSizeGridItem16 = (props: GridProps) => (
  <GridItem16 xs={16} sm={16} md={8} lg={4} {...props} />
);

/**
 * A {@link GridItem16} that always starts a new row. The full-width break
 * before it is not a grid item, so it takes no row spacing and no height.
 */
export const NewRowGridItem16 = (props: GridProps) => (
  <>
    <Box flexBasis="100%" />
    <GridItem16 {...props} />
  </>
);
